import { render } from "./RoomsView.vue?vue&type=template&id=32908da6"
import script from "./RoomsView.vue?vue&type=script&lang=js"
export * from "./RoomsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__